import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/insert`;

interface Props {
    className?: string;
}

export const InsertInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            インサート(おもり)の選び方
        </Title>
        <Image src={`${IMG_PATH}/insert.png`} />

        <Paragraph>
            矢のバランス、重量調整が自由にできるように、
            シャフト内にはめ込むタイプのインサート（おもり）がございます。
            矢尻と組合わせる事により、更に多種多様な矢を作製できます。
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpInsert: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <InsertInner />
            </div>
        </div>
    </Panel>
);
